<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <!-- <p v-if="isLoading" class="modal-card-title">Preview is loading <i class="fa fa-spinner fa-spin loading-icon fa-2x fa-fw"></i></p> -->
            <p class="modal-card-title">{{ subject || 'No subject' }}</p>
        </header>
        <section class="modal-card-body has-text-centered">
            <iframe :src="url"></iframe>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>
    export default {
        props: ['subject', 'url'],
    }
</script>

<style scoped>
.animation-content {
  width: 100%; }

.modal-card iframe {
  width: 100%;
  height: 70vh; }

</style>